import { ValidatorService } from './../../../../services/tools/validator.service';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ErrorsService } from '../../../../services/tools/errors.service';
declare var $;

@Component({
  selector: 'app-confirm-text-modal',
  templateUrl: './confirm-text-modal.component.html',
  styleUrls: ['./confirm-text-modal.component.scss']
})
export class ConfirmTextModalComponent implements OnInit {

  @Input()  title: string;
  @Input()  description: string;
  @Input() private callback: string;
  @Input() private callbackClose: string;
  @Input()  color: string;
  @Input()  buttonText: string;
  @Input()  text: string;
  @Input()  textSize: string;
  @Input()  textRequired: string;

  public textError: string;

  @Output() public goToCallback: EventEmitter<any> = new EventEmitter;

  constructor(private validatorService: ValidatorService, private errorService: ErrorsService) {
    this.color = this.defaultColor();
    this.buttonText = this.defaultButtonText();
  }

  ngOnInit() {
  }

  emit() {
    console.log('emitting text confirm ', this.text);
    if (this.callbackClose) {
      this.goToCallback.emit({
        'callback': this.callbackClose,
        'text': this.text,
      });
    }
    if (this.callback) {
      this.goToCallback.emit({
        'callback': this.callback,
        'text': this.text,
      });
    }
  }

  close(){
    $('#confirm-text-modal').modal('hide');
  }

  open(data) {
    this.fill(data);
    $('#confirm-text-modal').modal('show');
  }

  accept() {
    if (!this.validateText()) {
      return false;
    }
    this.emit();
    $('#confirm-text-modal').modal('hide');
  }

  validateText() {
    if (this.textRequired && !this.validatorService.required(this.text)) {
      this.textError = this.errorService.required;
      return false;
    } else if (this.textSize && !this.validatorService.max(this.text, this.textSize)) {
      this.textError = this.errorService.max(this.textSize);
      return false;
    } else {
      this.textError = undefined;
      return true;
    }
  }

  fill(data) {
    this.title = data.title;
    this.description = data.description;
    this.callback = data.callback;
    this.callbackClose = data.callbackClose;
    if (data.color) {
      this.color = data.color;
    } else {
      this.color = this.defaultColor();
    }
    if(data.text) {
      this.buttonText = data.buttonText;
    } else {
      this.buttonText = this.defaultButtonText();
    }

    this.text = (data.text)? data.text: '';
    this.textRequired = (data.textRequired)? data.textRequired: false;
    this.textSize = (data.textSize)? data.textSize: 600;
  }

  defaultColor() {
    return 'success';
  }

  defaultButtonText() {
    return 'Aceptar';
  }

}



// WEBPACK FOOTER //
// ./src/app/components/tools/modals/confirm-text-modal/confirm-text-modal.component.ts